import { Component, OnInit } from '@angular/core';
import { DataManagementService } from 'src/app/pages/data-management/data-management.service';

@Component({
  selector: 'app-info-device',
  templateUrl: './info-device.component.html',
  styleUrls: ['./info-device.component.scss'],
})
export class InfoDeviceComponent  implements OnInit {

  constructor(public dataManagementService: DataManagementService) { }

  ngOnInit() {}

}
